/**The type of form (used by form-service) */
export enum PageMenuType {
    Divider = 'divider',
    Button = 'button',
    Select = 'selectlist'
}
